import React, { useEffect, useState } from "react";
import axios from "axios";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate, NavLink } from "react-router-dom";
import { setUserProductCategories } from "../../redux/Actions/productCategoriesAction";
import { setCartCount, deleteCartCount } from "../../redux/Actions/cartCountAction";
import { setValue } from "../../utility";
import { LOCAL_API_BASE_URL } from "../../config";
import "./pricing.css";

const priceListData = {
  data: {
    Response: {
      response_code: "",
      response_message: "",
    },
    data: {},
  },
  rowcount: 0,
  active: "active",
};

const base_url = process.env.REACT_APP_BACKEND_URL;

function Pricing() {
  const [priceList, setPriceList] = useState<any | null>(priceListData);
  const [elRefs, setElRefs] = React.useState([]);
  const [active, setActive] = useState(null);
  const [showChat, setShowChat] = useState(false);
  const settings: any = useSelector<any>((state) => state.settings);
  const [genderType, setSelectedGender] = useState('both');
  let shopURL = window.location.href;
  const [userToken, setUserToken] = useState("");
  const state: any = useSelector<any>((state) => state);
  const navigate = useNavigate();

  const dispatch = useDispatch<any>();
  const selectedCategories: any = useSelector<any>(
    (state) => state.userSelectedCategories
  );
  const { cartCount }: any = useSelector<any>((state) => state);

  // Compute product count (number of distinct products with quantity > 0)
  const productCount = React.useMemo(() => {
    let count = 0;
    if (Array.isArray(selectedCategories)) {
      selectedCategories.forEach((cat: any) => {
        const sublist = cat.sub_categories?.filter((sub: any) => parseInt(sub.quantity) > 0);
        count += sublist?.length || 0;
      });
    }
    return count;
  }, [selectedCategories]);

  // --- cart helpers --------------------------------------------------------
  const findCategory = (list: any[], mainId: any) =>
    list?.find((c: any) => String(c.main_category_id) === String(mainId));

  const getQuantity = (mainCategory: any, subCategory: any) => {
    const cat = findCategory(
      Array.isArray(selectedCategories) ? selectedCategories : [],
      mainCategory.main_category_id
    );
    const sub = cat?.sub_categories?.find(
      (s: any) =>
        String(s.sub_category_id) === String(subCategory.sub_category_id)
    );
    return parseInt(sub?.quantity || "0");
  };

  const updateCart = (mainCategory: any, subCategory: any, delta: number) => {
    const mainId = String(mainCategory.main_category_id);
    const subId = String(subCategory.sub_category_id);
    let list: any[] = Array.isArray(selectedCategories)
      ? [...selectedCategories]
      : [];

    // ensure the main category exists in the cart list
    let cat = findCategory(list, mainId);
    if (!cat) {
      cat = { ...mainCategory };
      list = [...list, cat];
    }

    // ensure the sub category exists under it
    let subs: any[] = cat.sub_categories ? [...cat.sub_categories] : [];
    let sub = subs.find(
      (s: any) => String(s.sub_category_id) === subId
    );
    if (!sub) {
      sub = { ...subCategory, quantity: "0" };
      subs = [...subs, sub];
    }

    const currentQty = parseInt(sub.quantity || "0");
    const newQty = Math.max(0, currentQty + delta);
    if (newQty === currentQty) return; // e.g. remove pressed at 0

    const updatedCat = {
      ...cat,
      sub_categories: subs.map((s: any) =>
        String(s.sub_category_id) === subId
          ? { ...s, quantity: String(newQty) }
          : s
      ),
    };
    const updatedList = list.map((c: any) =>
      String(c.main_category_id) === mainId ? updatedCat : c
    );

    // push into the shared cart + header count
    dispatch(setUserProductCategories(updatedList));
    dispatch(delta > 0 ? setCartCount(cartCount + 1) : deleteCartCount(1));

    // persist so the cart survives into the product list / checkout flow
    const cartInformationData = updatedList.filter((c: any) =>
      c.sub_categories?.some((s: any) => parseInt(s.quantity) > 0)
    );
    setValue("cartInformationData", cartInformationData);
    localStorage.removeItem("is_removed");
  };
  useEffect(() => {
    if (localStorage.getItem("userDetails")) {
    }
    else {
      if(shopURL.includes("claphamdrycleaners")) {
        navigate("/login");
      }
    }
  }, []);

  useEffect(() => {
    const isXcelShop =
      shopURL?.includes("xceldrycleaner") ||
      (window.location.hostname === "localhost" &&
        LOCAL_API_BASE_URL?.includes("xceldrycleaner"));
    const isLaundryUp =
      shopURL?.includes("laundryup") ||
      (window.location.hostname === "localhost" &&
        LOCAL_API_BASE_URL?.includes("laundryup"));

    let metaTitle = "";
    let metaDescription = "";

    if (isXcelShop) {
      metaTitle = "Dry Cleaning Prices London | Xcel Dry Cleaners";
      metaDescription =
        "Transparent, affordable dry cleaning prices in London. No hidden fees. View our full price list and book a free collection today.";
    } else if (isLaundryUp) {
      metaTitle = "Laundry & Dry Cleaning Prices | LaundryUp Watford";
      metaDescription =
        "See our price list for wash & fold, dry cleaning, bedding, suits, shirts and alterations. Free pickup & delivery across Watford and nearby areas.";
    } else {
      return;
    }

    document.title = metaTitle;
    document.getElementById("title")?.setAttribute("content", metaTitle);
    document.getElementById("description")?.setAttribute("content", metaDescription);
  }, []);

  // useEffect(() => {
  //   console.log("Current userToken:", userToken); // Debug logging
  //   // Check if userToken is falsy (empty string, null, undefined, etc.)
  //   if (!userToken) {
  //     console.log("Redirecting to login because userToken is not set");
  //     // navigate("/login"); // Uncomment this when ready to redirect
  //   }
  // }, [userToken]);
  
  
  useEffect(() => {
    let currentShopId = localStorage.getItem("currentShopHome") || null;
    const url = new URL(window.location.href);
    const queryParamsShopId = url.searchParams.get("shop_id");
    const url_array = url.pathname.split("/").filter(Boolean);
    let shop_name = url_array[1];
    if (queryParamsShopId) {
      shop_name = queryParamsShopId;
      currentShopId = queryParamsShopId;
    }

    const headers = {
      Accept: "application/json",
    };

    axios
      .get(`${base_url}/api/get_categories?group_id=1&shop_name=${shop_name}&shop_id=${currentShopId}`, {
        headers: headers,
      })
      .then((e) => {
        setPriceList({ data: e.data });
        e.data.data.category
          .slice(0, 1)
          .map((category: any) => setActive(category.main_category_name));
      });
  }, []);

  const handleGenderChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedGender(e.target.value);
  };

  const handleClick = (event: any, category: any, catindex: any) => {
    setActive(category.main_category_name);
  };

  // useEffect(() => {
  //   if (shopURL.includes("hellocobbler")) {
  //     const script = document.createElement('script');
  //     script.type = 'text/javascript';
  //     script.async = true;
  //     script.src = 'https://embed.tawk.to/66b080431601a2195ba0d615/1i4gna25d';
  //     script.charset = 'UTF-8';
  //     script.setAttribute('crossorigin', '*');
  //     document.body.appendChild(script);

  //     return () => {
  //       document.body.removeChild(script);
  //     };
  //   }
  // }, [shopURL]);

  // const handleChatClick = () => {
  //   if (showChat) {
  //     if (window.Tawk_API) {
  //       window.Tawk_API.maximize();
  //     }
  //   } else {
  //     setShowChat(true);
  //     if (window.Tawk_API) {
  //       window.Tawk_API.showWidget();
  //     }
  //   }
  // };

  return (
    <div>     
      
      <section className="abt-section">
        <div className="about-us">
          <section className="price-section" id="pricing">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <Swiper
                    spaceBetween={15}
                    navigation={true}
                    modules={[Navigation]}
                    breakpoints={{
                      640: {
                        slidesPerView: 1,
                      },
                      768: {
                        slidesPerView: 4,
                      },
                      1024: {
                        slidesPerView: 7,
                      },
                    }}
                  >
                    {priceList.data?.data?.category?.map(
                      (category: any, catindex: any) => (
                        <SwiperSlide key={catindex}>
                          <div className="category-container">
                            <a
                              role="button"
                              className={
                                active == category.main_category_name
                                  ? "active-swiper"
                                  : ""
                              }
                              onClick={(event) =>
                                handleClick(event, category, catindex)
                              }
                            >
                              <div className="order_list">
                                <div className="user-img">
                                  <img
                                    src={category.web_banner_img}
                                    className="img-fluid"
                                    alt=""
                                  />
                                </div>
                                <div className="list-explore">
                                  <p> {category.main_category_name}</p>
                                </div>
                              </div>
                            </a>
                          </div>
                        </SwiperSlide>
                      )
                    )}
                  </Swiper>
                  {shopURL?.includes("hellocobbler") && (  
                  <div className="genderselection">
        <ul>
          <li>
            <input
              type="radio"
              id="both"
              value="both"
              checked={genderType === 'both'}
              onChange={handleGenderChange}
            />
            <label htmlFor="both">All</label>
          </li>
          <li>
            <input
              type="radio"
              id="male"
              value="male"
              checked={genderType === 'male'}
              onChange={handleGenderChange}
            />
            <label htmlFor="male">Men</label>
          </li>
          <li>
            <input
              type="radio"
              id="female"
              value="female"
              checked={genderType === 'female'}
              onChange={handleGenderChange}
            />
            <label htmlFor="female">Women</label>
          </li>
        </ul>
        
          {/* <button className="btn btntrans" onClick={handleChatClick}>
            Can't find your product?
          </button> */}
      </div>
                  )}
                  <div className="row">
                    <div className="col-md-12 list-collapse">
                      {priceList.data?.data?.category?.map(
                        (category: any, catindex: any) => (
                          <div
                            className="collapse-container first-collapse"
                            data-id="dry_cleaning"
                            data-main={catindex}
                            data-collapse-name={"slide-" + catindex}
                            key={catindex}
                          >
                            <div
                              id={"collapse-" + catindex}
                              data-uid={catindex}
                              className={
                                active == category.main_category_name
                                  ? "panel-collapse collapse show"
                                  : "panel-collapse collapse"
                              }
                              role="tabpanel"
                              aria-labelledby={"heading-" + catindex}
                              aria-expanded="true"
                            >
                              <div
                                className={
                                  active == category.main_category_name
                                    ? "panel-body collapse-body pricing-list-cloth"
                                    : "panel-body collapse-body pricing-list-cloth height-0"
                                }
                              >
                                <div className="price-box">
                                  <ul className="list-group">
                                    {category.sub_categories
                                      .filter(
                                        (subCategory: any) =>
                                          genderType === 'both' ||
                                          subCategory.gender_type === genderType
                                      )
                                      .map(
                                        (
                                          sub_category: any,
                                          subcatindex: any
                                        ) => (
                                          <li
                                            className="list-group-item"
                                            key={subcatindex}
                                          >
                                            <div className="price-list">
                                              <div className="price-pro-title">
                                                {sub_category.sub_category_name}
                                              </div>
                                              <div className="price-pro-cont">
                                                <span
                                                  className="homeprice"
                                                  data-bs-toggle="tooltip"
                                                  data-html="true"
                                                  title={sub_category.options
                                                    .filter(
                                                      (options: any) =>
                                                        options.is_default ==
                                                        "1"
                                                    )
                                                    .map(
                                                      (item: any) =>
                                                        `${item.option_name} : ${item.option_price}`
                                                    )
                                                    .join(", ")}
                                                >
                                                  {
                                                    settings?.WebmasterSettings
                                                      ?.currency
                                                  }
                                                  {sub_category.total_price}
                                                </span>
                                                {getQuantity(category, sub_category) > 0 ? (
                                                  <span className="plr__stepper">
                                                    <button
                                                      type="button"
                                                      className="plr__step-btn"
                                                      aria-label="Remove one"
                                                      onClick={() =>
                                                        updateCart(category, sub_category, -1)
                                                      }
                                                    >
                                                      &minus;
                                                    </button>
                                                    <span className="plr__step-qty">{getQuantity(category, sub_category)}</span>
                                                    <button
                                                      type="button"
                                                      className="plr__step-btn"
                                                      aria-label="Add one"
                                                      onClick={() =>
                                                        updateCart(category, sub_category, 1)
                                                      }
                                                    >
                                                      +
                                                    </button>
                                                  </span>
                                                ) : (
                                                  <button
                                                    type="button"
                                                    className="plr__add-btn"
                                                    onClick={() =>
                                                      updateCart(category, sub_category, 1)
                                                    }
                                                  >
                                                    Add
                                                  </button>
                                                )}
                                              </div>
                                            </div>
                                          </li>
                                        )
                                      )}
                                    {category.sub_categories.filter(
                                      (subCategory: any) =>
                                        genderType === 'both' ||
                                        subCategory.gender_type === genderType
                                    ).length === 0 && (
                                      <li className="list-group-item">
                                        No sub-categories available for the
                                        selected gender type.
                                      </li>
                                    )}
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        )
                      )}
                    </div>
                  </div>
                  {productCount > 0 && (
                    <div className="row justify-content-center text-center mt-3">
                      <div className="col-md-12 text-center">
                        <a href="javascript:;" id="toggle-cart" className="plr__go-to-cart-btn" onClick={() => {
                          const cdcart = document.getElementById("cd-cart");
                          const cartoverlay = document.getElementById("cd-shadow-layer");
                          if (cdcart && cartoverlay) {
                            cdcart.classList.add("speed-in");
                            cartoverlay.classList.add("is-visible");
                          }
                        }}>
                          <i className="fa fa-shopping-cart" style={{ marginRight: '8px' }}></i>
                          View Cart ({productCount})
                        </a>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              {shopURL?.includes("claphamdrycleaners") && (  
              <div className="row">
                <div className="col-md-12">
                  <p className="notedc">IF you want us to pick and drop please contact us</p>
                </div>
              </div>
              )}
            </div>
          </section>
        </div>
      </section>
    </div>
  );
}

export default Pricing;
